import { useState } from "react";
import { useDebouncedCallback } from "use-debounce";

export function useDebouncedOnChangeSearchQuery(
	defaultSearchQueryValue: string | undefined,
	onSearchQueryChange: (query: string) => void
) {
	const [currSearchQuery, setCurrSearchQuery] = useState(defaultSearchQueryValue);
	const [debouncing, setDebouncing] = useState(false);
	const debouncedOnChangeSearchQuery = useDebouncedCallback((value: string) => {
		setDebouncing(false);
		onSearchQueryChange(value);
	}, 200);

	return {
		currSearchQuery,
		debouncing,
		debouncedOnChangeSearchQuery: (searchQuery: string) => {
			setDebouncing(true);
			setCurrSearchQuery(searchQuery);
			debouncedOnChangeSearchQuery(searchQuery);
		},
	};
}
